// extracted by mini-css-extract-plugin
export var button = "Button-module--button--60c00";
export var buttonLink = "Button-module--buttonLink--acb68";
export var center = "Button-module--center--06158";
export var fill = "Button-module--fill--91f32";
export var left = "Button-module--left--50562";
export var right = "Button-module--right--dcab9";
export var underline = "Button-module--underline--bad15";